import React from 'react';
import Navbar from '../components/farh/layout/nav';
import Property from '../components/farh/common/property';
import SecHead from '../components/farh/layout/secHeading';

import heroimg2 from './../assets/heroimg01.png'
import Searchbar from '../components/farh/layout/searchbar';
import propertyimg1 from "./../assets/cardimg01.jpg"
import propertyimg2 from "./../assets/cardimg02.jpg"
import propertyimg3 from "./../assets/cardimg03.jpg"
import propertyimg4 from "./../assets/cardimg04.jpg"
import propertyimg5 from "./../assets/cardimg05.jpg"
import propertyimg6 from "./../assets/cardimg06.jpg"
import Swipe from '../components/janna/common/swipe';
import Review from '../components/farh/common/reviews';
import Footer from '../components/janna/layout/footer';
const Properties = () => {
    return ( <>
    <Navbar />

    <main>
{/* 1 */}
 <section>
                <div className="container hero ">
                    <h1 className='fadeIn'>
                Find your new <span>home</span> here.
            </h1>
                    <div className="heroimg1 heroimg2">
                        <img className='floatIn'  src={heroimg2} alt="" />
                        <div></div>
                    </div>                    
                </div>
                <Searchbar />
            </section>
            <section>
                <div className="container">
                    <div className='whychooseusdiv1'>
                    {/* 1 */}
                    <Property 
                    img={propertyimg1} 
                    location="New Cairo" 
                    title="Palm Hills New Cairo" 
                    price="3,500,000" 
                    statustype="status1" 
                    statustxt="Ready to Move" 
                    />

                    {/* 2 */}
                    <Property 
                    img={propertyimg2} 
                    location="Sheikh Zayed" 
                    title="Zed West Residence" 
                    price="4,200,000" 
                    statustype="status2" 
                    statustxt="Under Construction" 
                    />

                    {/* 3 */}
                    <Property 
                    img={propertyimg3} 
                    location="6th of October" 
                    title="Mountain View iCity" 
                    price="2,850,000" 
                    />

                    {/* 4 */}
                    <Property 
                    img={propertyimg4} 
                    location="New Administrative Capital" 
                    title="Il Bosco City" 
                    price="5,100,000" 
                    statustype="status2" 
                    statustxt="Limited Units" 
                    />

                    {/* 5 */}
                    <Property 
                    img={propertyimg5} 
                    location="North Coast" 
                    title="Hacienda Bay" 
                    price="6,750,000" 
                    statustype="status1" 
                    statustxt="Ready" 
                    />

                    {/* 6 */}
                    <Property 
                    img={propertyimg6} 
                    location="Ain Sokhna" 
                    title="La Vista Gardens" 
                    price="3,150,000" 
                    />
                    </div>
                    <Swipe swipe="swipediv swipediv2" />
                </div>
            </section>
            <section>
               <div className='whychooseussec'>
                 <div className="container ">
                    <SecHead style3='secHeading1' title='What Customers Think' sub1="Reviews" sub2="Explore handpicked residential and commercial projects across Egypt." />   
                </div>
<div className="carousel-wrapper">
    <div className="blurred_separator">
                        </div>
                        <div className=" blurred_separator2">
                        </div>
                <div className="carousel carousel2">
                    <Review name="Omar Wafa, Egypt"  text="“Investing with Maison Luxeuse was the best decision we've made. Their properties are a class apart.”"/>
                <Review name="Francois Digol, France"  text="“Investing with Maison Luxeuse was the best decision we've made. Their properties are a class apart.”"/>
                <Review name="Omar Wafa, Egypt"  text="“Investing with EgyRealty was the best decision we've made. Their properties are a class apart.”"/>
                </div>

</div>
               </div>
            </section>
    </main>
    <Footer />
    </> );
}
 
export default Properties;